import React from 'react'
import { NumberField } from 'react-admin'
import Exporter from 'services/csv/exporter'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const PhysicalExperienceUpsellingList: React.FC<CatalogItemBaseListProps> = (
  props
) => (
  <CatalogItemBaseList {...props} exporter={Exporter()}>
    <NumberField
      source="component.perGuestDefaultCost"
      label="Guest Default Cost"
      sortable={false}
    />
  </CatalogItemBaseList>
)

export default PhysicalExperienceUpsellingList
